export const BODYWORK_SEDAN = 'sedan'
export const BODYWORK_COMBI = 'combi'
export const BODYWORK_HATCHBACK = 'hatchback'
export const BODYWORK_LIFTBACK = 'liftback'
export const BODYWORK_LIMOUSINE = 'limousine'
export const BODYWORK_MPV = 'mpv'
export const BODYWORK_SUV = 'suv'
export const BODYWORK_CONVERTIBLE = 'convertible'
export const BODYWORK_COUPE = 'coupe'
export const BODYWORK_VAN = 'van'
export const BODYWORK_DELIVERY_VAN = 'delivery_van'
export const BODYWORK_FURGON = 'furgon'
export const BODYWORK_BUS = 'bus'
export const BODYWORK_CHASSIS_PLATFORM = 'chassis_platform'
export const BODYWORK_CHASSIS_CAB = 'chassis_cab'
export const BODYWORK_PICKUP = 'pickup'
export const BODYWORK_PLATFORM_TRUCK = 'platform_truck'
export const BODYWORK_DUMP_TRUCK = 'dump_truck'
export const BODYWORK_CABINET = 'cabinet'
export const BODYWORK_CARAVAN = 'caravan'
export const BODYWORK_ROADSTER = 'roadster'
export const BODYWORK_TARGA = 'targa'
export const ALL_BODYWORKS = [
  BODYWORK_SEDAN,
  BODYWORK_COMBI,
  BODYWORK_HATCHBACK,
  BODYWORK_LIFTBACK,
  BODYWORK_LIMOUSINE,
  BODYWORK_MPV,
  BODYWORK_SUV,
  BODYWORK_CONVERTIBLE,
  BODYWORK_COUPE,
  BODYWORK_VAN,
  BODYWORK_DELIVERY_VAN,
  BODYWORK_FURGON,
  BODYWORK_BUS,
  BODYWORK_CHASSIS_PLATFORM,
  BODYWORK_CHASSIS_CAB,
  BODYWORK_PICKUP,
  BODYWORK_PLATFORM_TRUCK,
  BODYWORK_DUMP_TRUCK,
  BODYWORK_CABINET,
  BODYWORK_CARAVAN,
  BODYWORK_ROADSTER,
  BODYWORK_TARGA,
] as const
